import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CountryPicker from './CountryPicker';
import { parsePhoneInput, looksLikeInternationalInput } from '../utils/phoneCanonical';
import { countries } from '../utils/phoneCanonical';

const defaultCountry = countries.find((c) => c.iso2 === 'AU') || countries[0];

function PhoneSearch() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = parsePhoneInput(phoneNumber, selectedCountry);
      if (result.error) {
        setError(result.error);
        return;
      }

      if (
        looksLikeInternationalInput(phoneNumber.trim(), phoneNumber.replace(/\D/g, '')) &&
        result.country &&
        result.country.iso2 !== selectedCountry.iso2
      ) {
        setSelectedCountry(result.country);
      }

      navigate(`/number/${result.canonicalId}`);
    } catch (err) {
      console.error('Error:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Search Phone Number</h2>

      <form onSubmit={handleSearch} className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-2">
          <CountryPicker
            value={selectedCountry.iso2}
            onChange={setSelectedCountry}
            disabled={loading}
          />
          <div className="flex-1">
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
                setError('');
              }}
              placeholder={selectedCountry.exampleFormat || 'Enter phone number...'}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>

        <p className="text-xs text-gray-500">
          Enter a local number with country selected, or include the full international code (e.g. +61…).
        </p>

        {error && <p className="text-sm text-red-600">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 px-4 rounded text-white ${
            loading
              ? 'bg-blue-300 cursor-not-allowed'
              : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </form>
    </div>
  );
}

export default PhoneSearch;
